var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 38,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1,
    y: 0.5,
    fill: "#fff",
    rx: 18.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    x: 1,
    y: 0.5,
    stroke: "#D6D6D6",
    rx: 18.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M27.389 11a2 2 0 0 1 1.888 1.34l-9.33 7.366a.9.9 0 0 1-1.116 0L9.5 12.34A2.005 2.005 0 0 1 11.389 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M11.5 27a2 2 0 0 1-2-2V14.5l9.44 7.206a.9.9 0 0 0 1.116 0L29.5 14.5V25a2 2 0 0 1-2 2z"
  })));
};
export default SvgEmail;